import gsap from 'gsap';
import { defineElement } from '~/utils/gw-utils';

class IngredientOverlay extends HTMLElement {
  constructor() {
    super();
    this.accordionBlocks = this.querySelectorAll('accordion-block');
  }

  connectedCallback() {
    this.attachEventListeners();
  }

  attachEventListeners() {
    this.accordionBlocks.forEach((accordionBlock) => {
      const details = accordionBlock.querySelector('details');
      details.addEventListener('toggle', () => {
        const ingredient = accordionBlock.getAttribute('data-ingredient');
        const overlay = accordionBlock.getAttribute('data-ingredient-overlay');

        if (details.open && overlay) {
          if (window.innerWidth < 767) return;
          this.showIngredient(ingredient, overlay);
        } else {
          this.hideIngredient();
        }
      });
    });
  }

  async showIngredient(ingredient, overlay) {
    const mainSwiperContainer = document.querySelector('.product-gallery__main');
    const mainImageSwiperSlide = mainSwiperContainer.querySelector('swiper-slide');

    // Slide to main image
    mainSwiperContainer.swiper.slideTo(0);
    // Add 500ms delay to wait for the slide transition
    await new Promise((resolve) => setTimeout(resolve, 500));

    // Hide active ingredient
    let activeIngredient = mainImageSwiperSlide.querySelector('[data-ingredient-overlay]');

    const hideActiveIngredientPromise = new Promise((resolve) => {
      if (activeIngredient) {
        this.hideIngredient().then(resolve);
      } else {
        resolve();
      }
    });

    hideActiveIngredientPromise.then(() => {
      // Create ingredient image element
      const ingredientImageElement = document.createElement('img');
      ingredientImageElement.setAttribute('data-ingredient-overlay', ingredient);
      // TODO: Move this into a metafield
      ingredientImageElement.src = overlay;

      mainImageSwiperSlide.appendChild(ingredientImageElement);

      gsap.set(ingredientImageElement, {
        autoAlpha: 0,
        position: 'absolute',
        left: 0,
        top: 0,
        y: 100,
      });

      gsap.to(ingredientImageElement, {
        autoAlpha: 1,
        duration: 0.5,
        y: 0,
        ease: 'power2.out',
      });
    });
  }

  async hideIngredient() {
    const ingredientOverlayMedia = document.querySelector('.ingredient-overlay__media');
    const mainSwiperContainer = document.querySelector('.product-gallery__main');
    const mainImageSwiperSlide = mainSwiperContainer.querySelector('swiper-slide');
    const ingredientImageElement = mainImageSwiperSlide.querySelector('[data-ingredient-overlay]');

    if (!ingredientImageElement) {
      return Promise.resolve();
    }

    return gsap.to(ingredientImageElement, {
      autoAlpha: 0,
      duration: 0.5,
      y: 100,
      ease: 'power2.out',
      onComplete: () => {
        ingredientImageElement.remove();
      },
    });
  }
}

defineElement('ingredient-overlay', IngredientOverlay);
